// slider functionality
var slide_index = 0 
function slideTo (direction, slide_count) {
  var slide_wrapper = document.querySelector('.eff_slider_wrapper')
  var _index = parseInt(direction, 10)
  if(!isNaN(_index)) {
    slide_index = _index
  }
  else {
    if(direction === '-') {
      slide_index = (slide_index > 0) ? (slide_index-1) : (slide_count - 1)
    }
    else {
      slide_index = (slide_index < (slide_count - 1)) ? (slide_index+1) : 0
    }
  }
  slide_wrapper.style.transform = 'translateX(' + (-100 * slide_index) + '%)'
  var page_dots = document.querySelectorAll('[aria-controls="eff_slider-"] .tap-area')
  page_dots.forEach((page_dot, pd_index) => {
    page_dot.attributes['aria-current'].value = pd_index === slide_index ? 'true' : 'false'
  })
}

// animated values and widths with intersection observer
var carousel_id = 'carousel-';
console.log(`carousel_id: ${carousel_id}`);
var carousel_element = document.getElementById(carousel_id);
console.log(`carousel_element: ${carousel_element}`);
function handleIntersect(entries, observer, type, final_value) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (entry.intersectionRatio >= 1) {
        animateValue(entry.target, 0, final_value, 3000, type);
        observer.unobserve(entry.target);
      }
    }
  });
}
function createObserver(number_el, type, final_value) {
  var mn_int_obs = new IntersectionObserver((entries, observer) => handleIntersect(entries, observer, type, final_value), {
    root: carousel_element,
    rootMargin: "0px",
    threshold: 1
  });
  mn_int_obs.observe(number_el);
}
function animateValue(obj, start, end, duration, type = 'value') {
  var start_timestamp = null;
  var anim_step = function(timestamp) {
    if (!start_timestamp) start_timestamp = timestamp;
    var progress = Math.min((timestamp - start_timestamp) / duration, 1);
    var anim_value = new Intl.NumberFormat().format(Math.floor(progress * (end - start) + start));
    if(type === 'value') {
      obj.innerHTML = anim_value;
    }
    else {
      obj.style.width = anim_value + '%';
    }
    if (progress < 1) {
      window.requestAnimationFrame(anim_step);
    }
  };
  window.requestAnimationFrame(anim_step);
}

function gatherAnimatedElements() {
  var animate_width = document.querySelectorAll('[data-animate-width]');
  var animate_value = document.querySelectorAll('[data-animate-value]');
  for (var aw_i = 0; aw_i < animate_width.length; aw_i++) {
    var final_width = parseFloat(animate_width[aw_i].attributes['data-animate-width'].value || 0)
    createObserver(animate_width[aw_i], 'width', final_width);
  }
  for (var ava_i = 0; ava_i < animate_value.length; ava_i++) {
    var final_value = parseFloat(animate_value[ava_i].attributes['data-animate-value'].value || 0)
    createObserver(animate_value[ava_i], 'value', final_value);
  }
}

document.addEventListener("DOMContentLoaded", gatherAnimatedElements);